import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { QueryKeys } from "config/query-keys";
import { AvailabilityInterface } from "./dto";
import { getDocs, query, where, collection } from "firebase/firestore";
import { db } from "../../../firebase/firebase";

const getEnumeratorAvailabilityStatus = async (uid: string): Promise<AvailabilityInterface> => {
  try {
    const dataCollection = collection(db, "user_infos");
    const userQuery = query(dataCollection, where("uid", "==", uid));
    const querySnapshot = await getDocs(userQuery);

    if (querySnapshot.empty) {
      throw new Error("User not found");
    }

    const userData = querySnapshot.docs[0].data();
    return userData.isAvailable as AvailabilityInterface;
  } catch (error) {
    console.error("Failed to fetch enumerator availability:", error);
    throw new Error("Failed to fetch availability. Please try again.");
  }
};

export const useGetEnumeratorAvailabilityStatus = (uid: string) => {
  return useQuery<AvailabilityInterface, AxiosError>({
    queryKey: [QueryKeys.ENUMERATOR, uid],
    queryFn: () => getEnumeratorAvailabilityStatus(uid),
    enabled: !!uid, // Ensure the query runs only if uid is available
  });
};
